export default __webpack_public_path__ + "static/ribbon-f4307732bf92855b215beb8c6dbde5cc.svg";